// extracted by mini-css-extract-plugin
export default {"root":"LockAvailabilityOverrideForm_root__J8uI5"};